<template>
  <el-footer>Footer</el-footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_a7d3be')
    }
  },
  methods: {
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sub/Footer.vue